import { render, staticRenderFns } from "./pane-details.vue?vue&type=template&id=7af56762&scoped=true"
import script from "./pane-details.vue?vue&type=script&lang=js"
export * from "./pane-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af56762",
  null
  
)

export default component.exports